export const clearChannelsEpg = (lives) =>
	lives.map((live) => ({ ...live, epgProgrammes: [] }));
